import { render, staticRenderFns } from "./PeopleOverviewPullout.vue?vue&type=template&id=3a3dd1e0&scoped=true&"
import script from "./PeopleOverviewPullout.vue?vue&type=script&lang=js&"
export * from "./PeopleOverviewPullout.vue?vue&type=script&lang=js&"
import style0 from "./PeopleOverviewPullout.vue?vue&type=style&index=0&id=3a3dd1e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a3dd1e0",
  null
  
)

export default component.exports